import type { CalculatorFormValues } from "@netkeep/validation";
import { KEYS, readJson, writeJson } from "./storage";

export interface SavedCalculation {
  id: string;
  createdAt: string;
  title: string;
  profileId: string;
  profileName: string;
  values: CalculatorFormValues;
  /** Money stays a decimal string, never a JS number, to avoid float rounding. */
  netProfit: string;
  netPayout: string;
  currency: string;
}

export class SaveError extends Error {}

/** Saved calculations live in this browser only (localStorage), newest first. */
export function listSaved(): SavedCalculation[] {
  const rows = readJson<unknown>(KEYS.saved);
  if (!Array.isArray(rows)) return [];
  return (rows as SavedCalculation[])
    .filter((r) => r && typeof r.id === "string" && typeof r.netProfit === "string" && r.values != null)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
}

function store(rows: SavedCalculation[]): void {
  if (!writeJson(KEYS.saved, rows)) {
    throw new SaveError("This browser is not letting NetKeep save data (private mode or storage is full).");
  }
}

export function saveCalculation(entry: Omit<SavedCalculation, "id" | "createdAt">): SavedCalculation {
  const row: SavedCalculation = { ...entry, id: crypto.randomUUID(), createdAt: new Date().toISOString() };
  store([row, ...listSaved()]);
  return row;
}

export function deleteSaved(id: string): void {
  store(listSaved().filter((r) => r.id !== id));
}

export function clearSaved(): void {
  store([]);
}
